import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from "recharts";
import { levelWord } from "@/lib/api";

export const Meter = ({ label, value, color = "#D96B43", testId }) => (
  <div data-testid={testId}>
    <div className="flex justify-between text-sm">
      <span className="text-slate-700">{label}</span>
      <span className="font-mono-ui text-xs text-slate-500">{Math.round(value)} · {levelWord(value)}</span>
    </div>
    <div className="mt-1.5 h-2 rounded-full bg-[#1C242B]/8 overflow-hidden bg-slate-200/70">
      <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${value}%`, background: color }} />
    </div>
  </div>
);

export const RadarCard = ({ title, data, testId, color = "#D96B43" }) => {
  const rows = Object.entries(data).map(([k, v]) => ({ k, v }));
  return (
    <div data-testid={testId} className="rounded-2xl bg-white border border-[#1C242B]/10 p-6">
      <p className="overline-label">{title}</p>
      <div className="h-[300px] mt-2">
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart data={rows} outerRadius="62%">
            <PolarGrid stroke="#1C242B22" />
            <PolarAngleAxis dataKey="k" tick={{ fontSize: 11, fill: "#475569", fontFamily: "Figtree" }} />
            <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
            <Radar dataKey="v" stroke={color} fill={color} fillOpacity={0.28} strokeWidth={2} />
          </RadarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export const MeterCard = ({ title, items, testId, color }) => (
  <div data-testid={testId} className="rounded-2xl bg-white border border-[#1C242B]/10 p-6">
    <p className="overline-label mb-5">{title}</p>
    <div className="grid gap-4">
      {items.map(([label, v]) => <Meter key={label} label={label} value={v} color={color} />)}
    </div>
  </div>
);
